<template>
  <div class="sidebar_container">
    <div style="flex: 1; overflow-y: scroll; padding-bottom: 10px">
      <ul class="pl-0 mt-2">
        <li class="sidebar_item">
          <div class="navigation_container" v-on:click="sendPageChangeEvent('manage_billing', $event)" :class="activeClass('manage_billing')">
            <img class="sidebar_icons_selected" v-if="activeClass('manage_billing')" :src="imagePath.selected_manage_billing" alt="selected_manage_billing" />
            <img class="sidebar_icons" v-else :src="imagePath.manage_billing" alt="manage_billing" />
            <span
              class="sidebar_text"
              style="margin-left: 4px"
              :style="activeClass('manage_billing') ? 'color: var(--color-text-black);font-weight: 500;' : 'color: var(--color-text-gray);font-weight: 400;'"
              >{{ props.billingVersion === 'v4' ? 'Add Credits' : 'Manage Billing' }}</span
            >
          </div>
        </li>
        <li class="sidebar_item">
          <div class="navigation_container" v-on:click="sendPageChangeEvent('worker_activity', $event)" :class="activeClass('worker_activity')">
            <img class="sidebar_icons_selected" v-if="activeClass('worker_activity')" :src="imagePath.selected_worker_activity" alt="selected_worker_activity" />
            <img class="sidebar_icons" v-else :src="imagePath.worker_activity" alt="worker_activity" />
            <span
              class="sidebar_text"
              style="margin-left: 4px"
              :style="activeClass('worker_activity') ? 'color: var(--color-text-black);font-weight: 500;' : 'color: var(--color-text-gray);font-weight: 400;'"
              >Credits Usage</span
            >
          </div>
        </li>
        <!--        <li class="sidebar_item">-->
        <!--          <div class="navigation_container" v-on:click="sendPageChangeEvent('invoices', $event)" :class="activeClass('invoices')">-->
        <!--            <img class="sidebar_icons_selected" v-if="activeClass('invoices')" :src="imagePath.selected_invoices" alt="selected_invoices" />-->
        <!--            <img class="sidebar_icons" v-else :src="imagePath.invoices" alt="invoices" />-->
        <!--            <span class="sidebar_text" style="margin-left: 4px" :style="activeClass('invoices') ? 'color: var(--color-text-black);font-weight: 500;' : 'color: var(--color-text-gray);font-weight: 400;'">Invoices</span>-->
        <!--          </div>-->
        <!--        </li>-->
        <li v-if="paymentGateway === 'stripe'" class="sidebar_item">
          <div class="payment_container" v-on:click="openPaymentMethods">
            <div class="flex flex-row items-center">
              <img class="sidebar_icons" :src="imagePath.payment_methods" alt="payment_methods" />
              <span class="sidebar_text" style="margin-left: 4px; color: #666666; font-weight: 400">Payment Methods</span>
            </div>
            <div class="mr-2">
              <img class="open_in_new" :src="imagePath.open_in_new" alt="open_in_new" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { emit } from '@/javascript/eventBus';
import imagePath from '@/javascript/imagePath';
import { ref, watch } from 'vue';
import DashboardService from '@/services/DashboardService';
import DashboardServiceV4 from '@/services/DashboardServiceV4';

const props = defineProps({
  mainPage: { type: String, required: true },
  billingVersion: { type: String, default: '' },
});

const mainPage = ref('manage_billing');
// Default to null so the Payment Methods entry stays hidden until the IP-resolved
// gateway comes back. Show it only when we explicitly know it's Stripe (the only
// gateway that has a customer portal). Razorpay → stays hidden permanently.
const paymentGateway = ref(null);

watch(
  () => props.billingVersion,
  async (newVal) => {
    if (!newVal) return;
    try {
      const response = newVal === 'v4' ? await DashboardServiceV4.getOrCreateAccount() : await DashboardService.getOrCreateAccount();
      if (response?.payment_gateway) {
        paymentGateway.value = response.payment_gateway;
      }
    } catch (e) {
      console.error('Error fetching payment gateway:', e);
    }
  },
  { immediate: true }
);

const activeClass = (value) => {
  return props.mainPage === value ? 'sidebar_active' : '';
};

const openPaymentMethods = async () => {
  if (props.billingVersion === 'v4') {
    const response = await DashboardServiceV4.getCustomerPortal();
    if (response?.success && response.customer_portal) {
      window.open(response.customer_portal, '_blank', 'noopener,noreferrer');
    }
  } else {
    const response = await DashboardService.getCustomerPortal();
    if (response?.success && response.link) {
      window.open(response.link, '_blank', 'noopener,noreferrer');
    }
  }
};

const sendPageChangeEvent = (page, event) => {
  event.preventDefault();
  mainPage.value = page;
  emit('page_changed', {
    main_page: mainPage.value,
  });
};
</script>

<style scoped>
.sidebar_container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100vh - 50px);
  background-color: #f5f5f5;
  width: 225px;
  overflow-y: scroll;
  position: fixed;
  border-bottom: none;
  text-align: center;
  z-index: 999;
  color: var(--foreground-rgb);
}

.sidebar_item {
  list-style-type: none;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 8px;
  cursor: pointer;
}

.sidebar_text {
  padding-left: 4px;
  display: inline-flex;
  font-style: normal;
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;
  flex: none;
  order: 1;
  vertical-align: middle;
  cursor: pointer;
}

.sidebar_active {
  color: var(--text-color);
  background: #e0e0e0;
}

.sidebar_icons_selected {
  width: 20px;
  margin-left: 8px;
  height: 20px;
  order: 0;
}

.sidebar_icons {
  width: 20px;
  margin-left: 8px;
  height: 20px;
  border-radius: 1px;
}

.open_in_new {
  width: 18px;
  height: 18px;
}

.payment_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  justify-content: space-between;
}

.payment_container:hover {
  background: #e0e0e0;
}

.navigation_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  justify-content: left;
}

.navigation_container:active .navigation_text {
  color: white;
}

.navigation_container:active .navigation_logo_selected {
  display: flex;
}

.navigation_container:focus .navigation_logo_selected {
  display: flex;
}

.navigation_container:active .navigation_logo {
  display: none;
}

.navigation_container:hover {
  background: #e0e0e0;
}
</style>
